<div appScrollbarTheme >



<ng-container *ngIf="bookAppointment">
          <form [formGroup]='appointmentForm'>
                        <!-- <ion-input type='hidden' ></ion-input> -->
                        <div>
                        <div>
                          <!-- two vertical part design -->


                          <div class="col-padding map-div  col-sm-12 col-md-12 col-lg-12 col-sm-12 pull-left">
                           <div class="container" style="position: relative;">
                            <app-map #mapcomp style="width: 100%;" (foundCenters)="foundCentersFromMap($event);"
                            (centerSelected)="centerSelected($event);"></app-map>

                            <span class="beta-txt accessibility-plugin-ac">{{'SLOT_SEARCH.Beta' | translate}}</span>

                            <div class="note-block ">
                              <span><b>{{'SLOT_SEARCH.NOTE' | translate}} :</b></span> {{'SLOT_SEARCH.NOTE_DESC' | translate}}
                             </div>

                            <div class="map-avail-table col-sm-3 col-md-3 col-lg-3 col-sm-12 pull-left" *ngIf="showSlots">
                              <div class="avail-tbl">
                              <div class="date-ava">
                                <a class="my-close-btn" [routerLink]="[]" (click)="closeAvaibility()">×</a>
                                <div class="hospital-block" *ngIf="centerName != undefined && centerName != null">
                                  <h5 class="center-name-title"> {{centerName && centerName != '' ? centerName : centerDetails.name}}
                                    <span *ngIf="centerDetails?.fee_type == 'Paid'" class="paid-button ng-star-inserted">{{'SLOT_SEARCH.Paid' | translate}}</span></h5>
                                  <!-- <p class="center-name-text">{{centerDetails.addressString}}</p> -->
                                  <!-- <p class="price-list">COVAXIN: ₹250</p> -->
                                </div>
                              <div class="center-title">
                                <h3>
                                  <small *ngIf="fromDate && toDate">{{fromDate | date: 'dd MMM yyyy'}} - {{toDate | date: 'dd MMM yyyy'}}</small>
                                </h3>


                              </div>

                              <div class="datatable">

                                <table class="data-scroll" width="100%" border="0" cellpadding="0" cellspacing="0">
                                  <thead>
                                   <!-- <tr>
                                      <th colspan="2">Filter</th>
                                    </tr> -->

                                    <!-- <tr>
                                      <th style="width: 50%;">Date</th>
                                      <th style="width: 50%"></th>

                                    </tr> -->
                                  </thead>
                                  <tbody>
                                    <tr *ngFor="let slot of availableSlots">
                                      <td tabindex="0" class="dt" style="width: 40%;">
                                        <span>
                                         <!-- {{slot.day}}  -->
                                         {{slot?.dateDisplay}}
                                        </span>
                                        <br>
                                        <span class="age-limit">
                                          <!-- {{slot?.min_age_limit}} -->
                                          <span *ngIf="slot?.max_age_limit == undefined">{{slot?.min_age_limit}} {{'SLOT_SEARCH.ANDABOVE_LBL' | translate}}</span>
															            <span *ngIf="slot?.max_age_limit >= 44">{{slot?.min_age_limit}}-{{slot?.max_age_limit}} {{'SLOT_SEARCH.ONLY_LBL' | translate}}</span>
                                        </span>
                                      </td>
                                      <td class="sl" style="width:60%;">
                                        <ul class="slot-box">
                                        <li >




                                        <div  tabindex="0" *ngIf="slot?.available_capacity > 0" class="slot-block">
                                          <div class="vaccine-name"> {{slot?.vaccine}}</div>
                                         <div class="dosetotal" tabindex="0">
                                          <span tabindex="0" title="Dose 1" tooltip="Dose 1" theme="light" placement="top" show-delay="100">
                                               <p>D1</p>{{slot?.available_capacity_dose1 && slot?.available_capacity_dose1 > 0 ? slot?.available_capacity_dose1 : 0}}
                                          </span>

                                          <div tabindex="0" class="slot-available" [ngClass]="{'less-seat': slot?.available_capacity <= 10}">{{slot?.available_capacity}} </div>

                                         <span tabindex="0" title="Dose 2" tooltip="Dose 2" theme="light" placement="top" show-delay="100">
                                           <p>D2</p>
                                          {{slot?.available_capacity_dose2 && slot?.available_capacity_dose2 > 0 ? slot?.available_capacity_dose2 : 0}}
                                          </span>
                                        </div>
                                        

                                        </div>

                                        <div  tabindex="0" *ngIf="slot?.available_capacity <= 0" class="slot-block">
                                          <div tabindex="0" class="vaccine-name">{{slot?.vaccine}}</div>
                                          <div tabindex="0" class="slot-available no-seat"> {{'SLOT_SEARCH.Booked' | translate}} </div>
                                          <!-- <div class="age-limit">Age {{slot?.min_age_limit}}+</div> -->
                                        </div>

                                      </li>
                                    </ul>
                                      </td>

                                      <!-- <td>
                                        <p *ngIf="slot?.available_capacity > 0" class="center-name">{{slot?.available_capacity}}</p>
                                        <p *ngIf="slot?.available_capacity <= 0" class="center-name center-name-red">{{slot?.available_capacity}}</p>
                                      </td> -->
                                    </tr>

                                  </tbody>
                                 </table>
                              </div>




                              <div class="date-availability-wrap">
                                <div  tabindex="0" style="color:#000;" *ngIf="!showLoader && isCenterSelected && (!availableSlots || availableSlots.length <= 0)">
                                  <p style="margin: auto;padding:10px 15px;font-size: 13px;font-weight: 400;">{{'SLOT_SEARCH.No_appointments_are_available_in_this_period.' | translate}}</p>
                                </div>
                                <div tabindex="0" style="color: #000;" *ngIf="!showLoader && !isCenterSelected">
                                  <p style="margin: auto;padding:10px 15px">{{'SLOT_SEARCH.Please_select_center_to_book_your_appointment.' | translate}}</p>
                                </div>
                                <div tabindex="0" *ngIf="showLoader && (!availableSlots || availableSlots.length <= 0)">
                                  <img style="margin: 0px auto;display: block;    padding: 20px;" src="assets/images/loading.gif" >
                                </div>
                               </div>
                              </div>
                               <div class="pagination-block">
                                <div class="pagination-box">
                                  <div tabindex="0" class="covid-button-desktop ion-text-start book-btn">
                                    <ng-container>
                                      <a *ngIf="currentPage > 1" (click)="prevButtonClick()" class="prev-week"><span name="chevron-back-outline"></span> {{'SLOT_SEARCH.Prev_Week' | translate}}
                                      </a>
                                    </ng-container>
                                    </div>

                                  <div tabindex="0" class="covid-button-desktop ion-text-end book-btn-end">
                                    <ng-container>
                                      <a *ngIf="currentPage <= 11" (click)="nextButtonClick()" class="next-week">{{'SLOT_SEARCH.Next_Week' | translate}} <span name="chevron-forward-outline"></span>
                                      </a>
                                    </ng-container>
                                  </div>
                                </div>
                                <div size="12">
                                  <div class="covid-button-desktop ion-text-end book-btn button-container__right">
                                    <!-- <a [routerLink]="['/dashboard']" (click)="backClick()" *ngIf="showTables" class="not-now">Back</a> -->
                                    <!-- <button (click)="confirmAppointment();" *ngIf="showTables" class="register-btn vac-btn"> {{'Book' }}</button> -->
                                  </div>
                                </div>
                              </div>
                              </div>
                            </div>



                          </div>
                          </div>

                          <!-- two vertical part design -->


                          </div>
                        </div>
                      </form>
        </ng-container>


        <!-- book appointment -->

        <!-- <appointment-confirm *ngIf="confirmBooking" [confirmAppointmentDetails]="confirmAppointmentDetails"
          [linkedBeneficiaryList]="linkedBeneficiaryList"
          [disableSubmit]="disableSubmit"
          [addressString]="addressString"
          (onBookMyAppointment)="bookMyAppointment();"
          (onGotoAppointmentScreen)="gotoAppointmentScreen();"></appointment-confirm> -->

  </div>

  <div style="clear: both;"></div>

<!-- </divappScrollbarTheme>  -->
